import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import CustomText from "@components/CustomText";

export default function DropdownOption(props) {
  const { handlePress = () => {}, isSelected, item, data } = props;

  const handleClick = () => {
    handlePress(item.value);
  };

  return (
    <TouchableOpacity
      onPress={handleClick}
      style={{
        marginRight: 10,
        marginBottom: 10,
        borderWidth: 1,
        borderRadius: 10,
        borderColor: "rgba(0, 0, 0, 0.1)",
        paddingVertical: 12,
        paddingHorizontal: 5,
        backgroundColor: isSelected ? "#242424" : "white",
        alignItems: "center",
        flexGrow: 1,
        width: data.name === "gender" ? "25%" : "45%",
      }}
    >
      <CustomText
        style={{
          color: isSelected ? "white" : "#242424",
          fontFamily: "NotoSansDevanagari-Regular",
          position: "relative",
          top: 2,
          fontSize: 12,
        }}
      >
        {item.key}
      </CustomText>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({});
